// extracted by mini-css-extract-plugin
export default {"cls1":"PremiumButton-cls1___4ca0ed0b1407d1c0385","cls2":"PremiumButton-cls2__bf54cae683b879e3a0ce PremiumButton-cls1___4ca0ed0b1407d1c0385"};